module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"removeConfirm":"Are you sure you want to delete this document?"},"et":{"removeConfirm":"Are you sure you want to delete this document?"},"ru":{"removeConfirm":"Are you sure you want to delete this document?"}}')
  delete Component.options._Ctor
}
